




































































import store from '../../store'
import router from '../../router'

export default {
  data () {
    return {
      title: 'Data',
      drawer: false,
      items: [
        { title: 'Table 1', subtitle: 'Predicted daily intake of pasture for cows.', anchor: '#t1' },
        { title: 'Table 2', subtitle: 'Predicted daily pasture intake of weaner cattle', anchor: '#t2' },
        { title: 'Table 3', subtitle: 'Predicted daily pasture intake of pasture by ewes', anchor: '#t3' },
        { title: 'Table 4', subtitle: 'Predicted daily pasture intake of pasture by weaner sheep', anchor: '#t4' },
        { title: 'Table 5', subtitle: 'Predicted daily energy intake of pasture by ewes', anchor: '#t5' },
        { title: 'Table 6', subtitle: 'Predicted daily energy intake of pasture by weaner sheep', anchor: '#t6' },
        { title: 'Table 7', subtitle: 'Minimum pasture availability required for satisfactory production levels', anchor: '#t7' },
        { title: 'Table 8', subtitle: 'Approximate relationship between pasture height and kg green DM/ha', anchor: '#t8' },
        { title: 'Table 9', subtitle: 'Monthly pasture growth rate estimates', anchor: '#t9' },
        { title: 'Table 10', subtitle: 'Protein and energy requirements for sheep', anchor: '#t10' },
        { title: 'Table 11', subtitle: 'Protein and energy requirements for cattle', anchor: '#t11' },
        { title: 'Table 12', subtitle: 'Estimated digestibility, energy, protein & fibre value of pastures', anchor: '#t12' },
        { title: 'Table 13', subtitle: 'Estimated energy, protein & fibre values of common livestock feeds', anchor: '#t13' },
        { title: 'Table 14', subtitle: 'DSE values for different classes of sheep', anchor: '#t14' },
        { title: 'Table 15', subtitle: 'DSE values for different classes of cattle', anchor: '#t15' },
        { title: 'Table 16', subtitle: 'Pasture response to nitrogen', anchor: '#t16' },
        { title: 'Table 17', subtitle: 'Composition of common fertilisers', anchor: '#t17' },
        { title: 'Formulas', subtitle: 'Useful formulas', anchor: '#formulas' }
      ]
    }
  },

  store
}
